
import React from 'react';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { CardContent } from '@/components/ui/card';
import { Flame, AlertCircle, Gauge, ArrowDownCircle, Lightbulb, TrendingDown } from 'lucide-react';

const GasStatCards = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      <AnimatedCard 
        animation="fade-up" 
        delay={100}
        className="bg-white dark:bg-gray-800 border-none shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300"
      >
        <CardContent className="p-5 flex flex-col items-center">
          <div className="bg-gradient-to-br from-amber-100 to-amber-50 dark:from-amber-900/30 dark:to-amber-800/20 p-3 rounded-full mb-4 shadow-sm">
            <Lightbulb className="h-6 w-6 text-amber-600 dark:text-amber-400" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">Efficiency Potential</h3>
          <p className="text-2xl md:text-3xl font-bold mt-2 text-amber-600 dark:text-amber-400">12.5%</p>
          <p className="text-sm text-green-600 dark:text-green-400 mt-1 flex items-center">
            <span>Based on AI analysis</span>
          </p>
        </CardContent>
      </AnimatedCard>
      
      <AnimatedCard 
        animation="fade-up" 
        delay={200}
        className="bg-white dark:bg-gray-800 border-none shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300"
      >
        <CardContent className="p-5 flex flex-col items-center">
          <div className="bg-gradient-to-br from-amber-100 to-amber-50 dark:from-amber-900/30 dark:to-amber-800/20 p-3 rounded-full mb-4 shadow-sm">
            <TrendingDown className="h-6 w-6 text-amber-600 dark:text-amber-400" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">Safety Risk Index</h3>
          <p className="text-2xl md:text-3xl font-bold mt-2 text-amber-600 dark:text-amber-400">Low</p>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">1 potential issue detected</p>
        </CardContent>
      </AnimatedCard>
      
      <AnimatedCard 
        animation="fade-up" 
        delay={300}
        className="bg-white dark:bg-gray-800 border-none shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300"
      >
        <CardContent className="p-5 flex flex-col items-center">
          <div className="bg-gradient-to-br from-amber-100 to-amber-50 dark:from-amber-900/30 dark:to-amber-800/20 p-3 rounded-full mb-4 shadow-sm">
            <Gauge className="h-6 w-6 text-amber-600 dark:text-amber-400" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">Distribution Efficiency</h3>
          <p className="text-2xl md:text-3xl font-bold mt-2 text-amber-600 dark:text-amber-400">89%</p>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Target: 95%</p>
        </CardContent>
      </AnimatedCard>
      
      <AnimatedCard 
        animation="fade-up" 
        delay={400}
        className="bg-white dark:bg-gray-800 border-none shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300"
      >
        <CardContent className="p-5 flex flex-col items-center">
          <div className="bg-gradient-to-br from-amber-100 to-amber-50 dark:from-amber-900/30 dark:to-amber-800/20 p-3 rounded-full mb-4 shadow-sm">
            <AlertCircle className="h-6 w-6 text-amber-600 dark:text-amber-400" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">Advisory Actions</h3>
          <p className="text-2xl md:text-3xl font-bold mt-2 text-amber-600 dark:text-amber-400">2</p>
          <p className="text-sm text-red-500 dark:text-red-400 mt-1">1 safety critical</p>
        </CardContent>
      </AnimatedCard>
    </div>
  );
};

export default GasStatCards;
